// tslint:disable
/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTSharePointDocument,
} from './';

/**
 * @export
 * @interface RESTRestoreSharePointDocumentConfig
 */
export interface RESTRestoreSharePointDocumentConfig {
    /**
     * @type {RESTSharePointDocument}
     * @memberof RESTRestoreSharePointDocumentConfig
     */
    document: RESTSharePointDocument;
    /**
     * Specifies what version of the SharePoint document will be restored.
     * @type {string}
     * @memberof RESTRestoreSharePointDocumentConfig
     */
    documentVersion?: RESTRestoreSharePointDocumentConfigDocumentVersionEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTRestoreSharePointDocumentConfigDocumentVersionEnum {
    All = 'All',
    Last = 'Last'
}

